export const getFormattedDateWithSlash = (inputDate) => {
    if(!inputDate)return;
    if (inputDate?.toLowerCase() === "present") return "present";
    if (inputDate?.toLowerCase().includes("not")) return null;
    let formattedDate = inputDate;
    const parts = inputDate?.split('/');
    if (parts.length === 2) {
        const [month, year] = parts;
        formattedDate = `01/${month}/${year}`;
    }

    const [d, m, y] = formattedDate.split('/');
    const dateObject = new Date(`${m}/${d}/${y}`);
    const monthNames = [
        'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
        'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'
    ];
    const month = monthNames[dateObject.getMonth()];
    const year = dateObject.getFullYear().toString().slice(-2);
    if (!month || !year) return inputDate;
    const res = `${month} '${year}`;
    return res;
}

export const formatFullDateString = (inputDate) => {
    if(!inputDate)return;
    const months = [
        "Jan", "Feb", "Mar", "Apr", "May", "Jun",
        "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"
    ];
    const parsedDate = new Date(inputDate);
    const year = parsedDate.getFullYear();
    const month = months[parsedDate.getMonth()];
    const day = parsedDate.getDate();
    let daySuffix = "th";
    if (day === 1 || day === 21 || day === 31) {
        daySuffix = "st";
    } else if (day === 2 || day === 22) {
        daySuffix = "nd";
    } else if (day === 3 || day === 23) {
        daySuffix = "rd";
    }
    const formattedDate = `${day}${daySuffix} ${month} ${year}`;
    return formattedDate;
}


export const formatDateTime = (date) => {
    if(!date)return;
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    const seconds = String(date.getSeconds()).padStart(2, '0');

    return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
}